import { useQuery } from '@tanstack/react-query'
import { apiClient, authHeader } from '../lib/api'
import type { School, SchoolWithRecruiters, SchoolSearchParams } from '@tnf-recruit/shared'
import { useAuth } from './useAuth'

export interface SchoolSearchResult {
  data: School[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
}

export function useSchoolSearch(params: SchoolSearchParams, enabled = true) {
  const { getAccessToken } = useAuth()

  return useQuery({
    queryKey: ['schoolSearch', params],
    queryFn: async (): Promise<SchoolSearchResult> => {
      const token = await getAccessToken()
      const { data } = await apiClient.get('/schools/search', {
        ...authHeader(token),
        params,
      })

      return {
        data: data.data ?? [],
        pagination: data.pagination ?? { page: 1, limit: 20, total: 0, totalPages: 0 },
      }
    },
    enabled,
  })
}

export function useSchoolDetail(schoolId: string | undefined) {
  const { getAccessToken } = useAuth()

  return useQuery({
    queryKey: ['schoolDetail', schoolId],
    queryFn: async () => {
      const token = await getAccessToken()
      const { data } = await apiClient.get(`/schools/${schoolId}`, authHeader(token))
      return data.data as SchoolWithRecruiters
    },
    enabled: !!schoolId,
  })
}
